import React from 'react';
import {compose, graphql} from 'react-apollo';
import PropTypes from "prop-types";

import OperatorAdsQuery from 'gql/operator/ads.gql';

export function withOperatorAds(WrappedComponent) {
    class WithOperatorAds extends React.Component {
        static propTypes = {
            user: PropTypes.object.isRequired,
            operatorAdsQuery: PropTypes.object.isRequired
        };

        render() {
            return <WrappedComponent operatorAds={this.props.operatorAdsQuery.operatorAds} {...this.props}/>
        }
    }

    return compose(
        graphql(OperatorAdsQuery, {
            name: 'operatorAdsQuery',
            options: props => ({
                variables: {
                    operator: props.user.id
                }
            })
        }),
    )(WithOperatorAds);
}


// WEBPACK FOOTER //
// ./src/helpers/operatorAds.js